import { HighlightsTextItem } from '@cmg/design-system';
import { useIntl } from '@cmg/i18n';

import { Offering_OfferingHeader_OfferingTermsPartsFragment } from '../../../graphql';

type LastTradeBeforeTitleItemsProps = {
  terms?: Offering_OfferingHeader_OfferingTermsPartsFragment;
  pricingCurrencyCode?: string;
};

export default function LastTradeBeforeTitleItems({
  terms,
  pricingCurrencyCode,
}: Readonly<LastTradeBeforeTitleItemsProps>) {
  const intl = useIntl();

  if (terms?.followOnPricing?.lastTradeBeforeOffer) {
    return (
      <HighlightsTextItem
        name="LT BEFORE OFFER"
        text={intl.formatNumber(terms.followOnPricing.lastTradeBeforeOffer, {
          format: 'currency',
          currency: pricingCurrencyCode,
        })}
      />
    );
  }
  if (terms?.followOnPricing?.lastTradeBeforeLaunch) {
    return (
      <HighlightsTextItem
        name="LT BEFORE LAUNCH"
        text={intl.formatNumber(terms.followOnPricing.lastTradeBeforeLaunch, {
          format: 'currency',
          currency: pricingCurrencyCode,
        })}
      />
    );
  }
  if (terms?.followOnPricing?.lastTradeBeforeFiling) {
    return (
      <HighlightsTextItem
        name="LT BEFORE FILING"
        text={intl.formatNumber(terms.followOnPricing.lastTradeBeforeFiling, {
          format: 'currency',
          currency: pricingCurrencyCode,
        })}
      />
    );
  }
  return <HighlightsTextItem name="LT BEFORE OFFER" text="-" />;
}
